<template>
	<v-dialog v-model="dialogShare" max-width="600">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="bra-0" flat>How it works</v-btn>
        </template>
        <v-card>
            <div class="title px-2 py-3 text-xs-center"><v-icon>mdi-teach</v-icon> How to book a place book a place</div>
            <v-divider></v-divider>
            <div v-for="(step, i) in steps" class="body-1 px-3 py-3">
                <h4 class="title">{{i+1}}. {{step.title}}</h4>
                <div class="text-xs-center py-3">
                    <v-avatar tile size="100" class="white">
                        <img :src="step.img">
                    </v-avatar>
                </div>
                {{step.text}}
            </div>
            <v-divider></v-divider>
            <v-btn @click="dialogShare = !dialogShare" color="primary" flat><v-icon left>mdi-text-to-speech</v-icon> Got It!</v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
    	return {
    		dialogShare: false,
            steps: [
                {title: "Search our collections", img: "/assets/seo.png", text: "Using the search bar above, search for the lodge of your choice by. You can search by University, location or the name of the lodge. You can also filter the lodges you get in your result by price and other necessary feature you need in a lodge. Premium users have access to the whole directory of lodges. Be sure to favourite as many lodges that interests you. This will enable you get real time notifications on the vacancy number change, and the view count related to the lodge. Enabling you make well informed decisions before moving in."},
                {title: "Book throught us", img: "/assets/group.png", text: "We advise you book the lodge through us as this will enable us to provide superior customer service to you. When you book through us, we assist you on an onsite visit and tour to as many as 3 of your most preferred favourite lodges. As well as a free property move service."},
                {title: "Move in", img: "/assets/paper-plane.png", text: "As soon as you’ve decided to move in to a particular lodge, we will send you the account details of the landlord to make you payments and make sure you’re given a receipt. We will also assist you on the day you move in to make sure you feel at home."},
            ]
    	}
    }
}
</script>